
import { TranslationSet } from '../types';

export const features: TranslationSet = {
  'features.title': {
    en: 'Features designed for parents',
    ja: '親のために設計された機能',
    es: 'Funciones diseñadas para padres',
    zh: '为父母设计的功能',
    fa: 'ویژگی‌های طراحی شده برای والدین'
  },
  'features.description': {
    en: 'Everything you need to document your baby\'s journey',
    ja: '赤ちゃんの成長を記録するために必要なすべてのもの',
    es: 'Todo lo que necesitas para documentar tu viaje de bebé',
    zh: '您需要的所有东西来记录宝宝的成长',
    fa: 'همه چیزهایی که برای ثبت سفر کودک خود نیاز دارید'
  },
  'features.personalized': {
    en: 'Personalized Entries',
    ja: 'パーソナライズされたエントリー',
    es: 'Entradas personalizadas',
    zh: '个性化条目',
    fa: 'ورودی‌های شخصی‌سازی شده'
  },
  'features.photoGallery': {
    en: 'Photo Gallery',
    ja: 'フォトギャラリー',
    es: 'Galería de fotos',
    zh: '照片库',
    fa: 'گالری عکس'
  },
  'features.statistics': {
    en: 'Statistics Tracking',
    ja: '統計追跡',
    es: 'Seguimiento de estadísticas',
    zh: '统计跟踪',
    fa: 'پیگیری آمار'
  },
  'features.unlimited': {
    en: 'Unlimited Entries',
    ja: '無制限のエントリー',
    es: 'Entradas ilimitadas',
    zh: '无限条目',
    fa: 'ورودی‌های نامحدود'
  },
  'features.advancedGeneration': {
    en: 'Advanced Generation',
    ja: '高度な日記生成',
    es: 'Generación avanzada',
    zh: '高级日记生成',
    fa: 'تولید پیشرفته'
  },
  'features.healthInsights': {
    en: 'Health Insights',
    ja: '健康インサイト',
    es: 'Información de salud',
    zh: '健康洞察',
    fa: 'بینش‌های سلامت'
  }
};
